import AgendaItem from "@/domain/entities/agenda/AgendaItem";
import { format, Locale } from "date-fns";

const getFormattedDateTime = (event: AgendaItem, locale: Locale) => {
    let dateTime = `${format(event.start, "EEEE d MMMM yyyy - HH:mm", { locale })} -> ${format(
        event.end,
        "HH:mm",
        { locale },
    )}`;

    if (event.isAllDayEvent()) {
        dateTime = `${format(event.start, "EEEE d MMMM yyyy", { locale })}`;
    }

    if (event.isOnSeveralDays()) {
        dateTime = `${format(event.start, "EEEE d MMMM yyyy - HH:mm", { locale })} -> ${format(
            event.end,
            "EEEE d MMMM yyyy - HH:mm",
            { locale },
        )}`;
    }

    if (event.isOnSeveralDays() && event.isAllDayEvent()) {
        dateTime = `${format(event.start, "EEEE d MMMM yyyy", { locale })} -> ${format(
            new Date(event.end.getTime() - 1), // allDay events are set as finishing at midnight the text day, so we need to show the previous day for correct display
            "EEEE d MMMM yyyy",
            { locale },
        )}`;
    }

    return dateTime;
};

export default getFormattedDateTime;
